/**
 * Plain-language labels + small byte helpers shared across the Options tab. The operator
 * never sees the raw storage words `axis`/`modifier` — only "View options" / "Prompt
 * options" — but the underlying `kind`/`select` values stay unchanged on the wire.
 */
import type { OptionGroupKind, OptionSelect } from "@genz/platform";

export const KIND_LABELS: Record<OptionGroupKind, string> = {
  axis: "View options",
  modifier: "Prompt options",
};
export const KIND_HINTS: Record<OptionGroupKind, string> = {
  axis: "each pick creates a separate mock-up",
  modifier: "adds to the prompt — no extra images",
};
export const SELECT_LABELS: Record<OptionSelect, string> = {
  single: "Pick one",
  multi: "Pick several",
};

export const MIME_EXT: Record<string, string> = {
  "image/png": "png",
  "image/jpeg": "jpg",
  "image/webp": "webp",
};

export function bytesToBase64(bytes: Uint8Array): string {
  let bin = "";
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    bin += String.fromCharCode(...bytes.subarray(i, i + chunk));
  }
  return btoa(bin);
}
